import { render, staticRenderFns } from "./SparePartList.vue?vue&type=template&id=3a2543d3&"
import script from "./SparePartList.vue?vue&type=script&lang=js&"
export * from "./SparePartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports